import React from 'react'
import {
  WebMessageEventEmitter,
  Disposable,
  WebMessageEventEmitterConsumer
} from '../ReceiveMessageFromNative'
import { NavigateToMessage } from '../../services/dealNativeBridge'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface Props extends RouteComponentProps<{}> {
  eventEmitter: WebMessageEventEmitter
}

class NavigateOnEvent extends React.Component<Props> {
  private disposable?: Disposable

  public componentDidMount() {
    this.disposable = this.props.eventEmitter.on<NavigateToMessage>('navigateTo', msg => {
      if (msg.page.name === 'conversation') {
        this.props.history.push(`/inbox/${msg.page.conversationId}`)
      } else if (msg.page.name === 'orderConfirmation') {
        this.props.history.push(
          `/orders/${msg.page.orderId}/checkout/review?sid=${msg.page.paymentSourceId}`
        )
      } else {
        console.error('Request to navigate to unknown page: ', msg)
      }
    })
  }

  public componentWillUnmount() {
    this.disposable && this.disposable.dispose()
  }

  public render() {
    return null
  }
}

const NavigateOnEventWithRouter = withRouter(NavigateOnEvent)

const WrappedNavigateWithConsumer: React.SFC = () => (
  <WebMessageEventEmitterConsumer>
    {eventEmitter => {
      if (eventEmitter) {
        return <NavigateOnEventWithRouter eventEmitter={eventEmitter} />
      } else {
        return null
      }
    }}
  </WebMessageEventEmitterConsumer>
)

export default WrappedNavigateWithConsumer
